import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "@/api/api";

const useGetCollabEdit = () => {
  const [data, setData] = useState(null);
  const [loading, _setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCollabEdit = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get("/api/collab/settings/");
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchCollabEdit();
  }, [fetchCollabEdit]);

  return { data, loading, error, refetch: fetchCollabEdit };
};

export default useGetCollabEdit;

const useSaveCollabEdit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const saveCollabEdit = async (payload) => {
    setLoading(true);
    try {
      const response = await api_without_cancellation.put("/api/collab/settings/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { saveCollabEdit, loading, error, success };
};

export { useSaveCollabEdit };
